import DefaultFormContainer from '~/components/ui/DefaultFormContainer.vue';
import { getThemeData } from '~/utils';

export function useFormContainer() {

  const config = getThemeData();
  const theme = config.theme;

  const FormContainer = defineAsyncComponent({
    loader: () => import(`~/themes/${theme}/components/ui/FormContainer.vue`).catch(() => DefaultFormContainer),
  });

  return { FormContainer };
}